import { Component, OnInit, OnDestroy } from '@angular/core';
import { Response } from '@angular/http';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs/Rx';
import { EventManager, ParseLinks, PaginationUtil, JhiLanguageService, AlertService } from 'ng-jhipster';

import { Contractdate } from './contractdate.model';
import { ContractdateService } from './contractdate.service';
import { ITEMS_PER_PAGE, Principal } from '../../shared';
import { PaginationConfig } from '../../blocks/config/uib-pagination.config';

@Component({
    selector: 'jhi-contractdate',
    templateUrl: './contractdate.component.html'
})
export class ContractdateComponent implements OnInit, OnDestroy {
contractdates: Contractdate[];
    currentAccount: any;
    eventSubscriber: Subscription;
    currentSearch: string;

    constructor(
        private jhiLanguageService: JhiLanguageService,
        private contractdateService: ContractdateService,
        private alertService: AlertService,
        private eventManager: EventManager,
        private activatedRoute: ActivatedRoute,
        private principal: Principal
    ) {
        this.currentSearch = activatedRoute.snapshot.params['search'] ? activatedRoute.snapshot.params['search'] : '';
        this.jhiLanguageService.setLocations(['contractdate']);
    }

    loadAll() {
        if (this.currentSearch) {
            this.contractdateService.search({
                query: this.currentSearch,
                }).subscribe(
                    (res: Response) => this.contractdates = res.json(),
                    (res: Response) => this.onError(res.json())
                );
            return;
       }
        this.contractdateService.query().subscribe(
            (res: Response) => {
                this.contractdates = res.json();
                this.currentSearch = '';
            },
            (res: Response) => this.onError(res.json())
        );
    }

    search(query) {
        if (!query) {
            return this.clear();
        }
        this.currentSearch = query;
        this.loadAll();
    }

    clear() {
        this.currentSearch = '';
        this.loadAll();
    }
    ngOnInit() {
        this.loadAll();
        this.principal.identity().then((account) => {
            this.currentAccount = account;
        });
        this.registerChangeInContractdates();
    }

    ngOnDestroy() {
        this.eventManager.destroy(this.eventSubscriber);
    }

    trackId(index: number, item: Contractdate) {
        return item.id;
    }
    registerChangeInContractdates() {
        this.eventSubscriber = this.eventManager.subscribe('contractdateListModification', (response) => this.loadAll());
    }

    private onError(error) {
        this.alertService.error(error.message, null, null);
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/contractdate/contractdate.component.ts